import { render, staticRenderFns } from "./AboutEdit.vue?vue&type=template&id=2ec9b5a8&scoped=true"
import script from "./AboutEdit.vue?vue&type=script&lang=js"
export * from "./AboutEdit.vue?vue&type=script&lang=js"
import style0 from "./AboutEdit.vue?vue&type=style&index=0&id=2ec9b5a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec9b5a8",
  null
  
)

export default component.exports